import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-caret-down",
  "use": "oc-caret-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"oc-caret-down\"><path d=\"M675.456 593.28A38.4 38.4 0 0 0 640 569.6H384a38.4 38.4 0 0 0-27.136 65.536l128 128a38.4 38.4 0 0 0 54.272 0l128-128a38.4 38.4 0 0 0 8.32-41.856z\" p-id=\"1890\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol